import { useState } from 'react';
import './flippable-card.css';

export const FlippableCard = ({ frontContent, backContent, minHeight = '195px' }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleFlip = () => {
        setIsFlipped(!isFlipped);
    };

        return (
		<div className="flip-card" style={{ minHeight }} onClick={handleFlip}>
            <div className={`flip-card-inner ${isFlipped ? 'flipped' : ''}`}>
                <div className="flip-card-front">
                    <i className="fa fa-refresh flip-icon" title="Click to flip"></i>
                    {frontContent}
                </div>
                <div className="flip-card-back">
                    <i className="fa fa-refresh flip-icon" title="Click to flip back"></i>
                    {backContent}
                </div>
            </div>
        </div>
    );
};